import React, { useContext, useState } from 'react';
import { Context } from "../contexts/AppContext";

function VideoController() {

    const { value } = useContext(Context);  
    const [appState, setAppState] = value; 
  //console.log("VIDEO BG controller ",appState.currentGalleryData.backgroundMedia.videoUrl);
  const [videoUrl, setVideoUrl]=useState(`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.currentGalleryData?.backgroundMedia?.videoUrl}`)
  return (
    <div
      id="video-bg"
      className="absolute w-full h-full "
    > 
    {appState.currentGalleryData?.backgroundMedia?.videoUrl &&
      <video
        className="w-full h-full object-cover"
        crossOrigin="anonymous"
        autoPlay
        muted
        loop
        tabIndex={-1}
      >
        <source
         // src={ appState.backgroundMedia.videoUrl?`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.backgroundMedia.videoUrl}`:null}
        // src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.backgroundMedia.videoUrl}`}
       
         // src='https://dn9s152cefkpf.cloudfront.net/APRIL2025/WEDDING/W4.mp4'
        // src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.backgroundMedia.videoUrl}`}
         src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.currentGalleryData?.backgroundMedia?.videoUrl}`}
         
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>}
    </div>
  );
}

export default VideoController;
